// Module
var code = "<div class=\"dms-mapping-header\">\n    <h1 data-bind=\"html: getTextBlockpageTitle\"></h1>\n    <div data-bind=\"html: getTextBlockpageContent\" class=\"dms-textblock dms-pagecontent\"></div>\n</div>\n";
// Exports
export default code;